"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm$farm$cnpj, _vm$romaneio$clientDa, _vm$romaneio$clientDa2, _vm$romaneio$plotData, _vm$romaneio$subPlotD;
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    staticClass: "modal-romaneio-details",
    attrs: {
      width: 720,
      active: true,
      scroll: "keep"
    },
    on: {
      close: _vm.cancelModal
    }
  }, [_c("div", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "card-content"
  }, [_c("div", {
    staticClass: "media"
  }, [_c("div", {
    staticClass: "media-content"
  }, [_c("button", {
    staticClass: "btn-x-close",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.cancelModal
    }
  }, [_c("i", {
    staticClass: "icon-ic_close"
  })]), _vm._v(" "), _c("p", {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + " - " + _vm._s(_vm.romaneio.register) + "\n          ")])])]), _vm._v(" "), _c("div", {
    staticClass: "content"
  }, [_c("b-field", {
    attrs: {
      label: "CNPJ/CPF",
      expanded: ""
    }
  }, [_c("app-input", {
    attrs: {
      value: (_vm$farm$cnpj = _vm.farm.cnpj) !== null && _vm$farm$cnpj !== void 0 ? _vm$farm$cnpj : "--",
      disabled: ""
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Nº do Romaneio",
      expanded: ""
    }
  }, [_c("app-input", {
    attrs: {
      value: _vm.romaneio.register,
      disabled: ""
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Data da Colheita",
      expanded: ""
    }
  }, [_c("app-input", {
    attrs: {
      value: _vm.formatDate(_vm.romaneio.harvestDate),
      disabled: ""
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Placas do Veículo",
      expanded: ""
    }
  }, [_c("app-input", {
    attrs: {
      value: _vm.romaneio.plate,
      disabled: ""
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Total de Pallets",
      expanded: ""
    }
  }, [_c("app-input", {
    attrs: {
      value: _vm.romaneio.pallets,
      type: "number",
      disabled: ""
    }
  })], 1), _vm._v(" "), _c("hr"), _vm._v(" "), _c("h4", [_vm._v("Dados do Cliente")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Cliente",
      expanded: ""
    }
  }, [_c("app-input", {
    attrs: {
      value: (_vm$romaneio$clientDa = _vm.romaneio.clientData) === null || _vm$romaneio$clientDa === void 0 ? void 0 : _vm$romaneio$clientDa.name,
      disabled: ""
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "CPF / CNPJ",
      expanded: ""
    }
  }, [_c("app-input", {
    attrs: {
      value: (_vm$romaneio$clientDa2 = _vm.romaneio.clientData) === null || _vm$romaneio$clientDa2 === void 0 ? void 0 : _vm$romaneio$clientDa2.cpfcnpj,
      disabled: ""
    }
  })], 1), _vm._v(" "), _c("hr"), _vm._v(" "), _c("h4", [_vm._v("Dados da Área")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Área",
      expanded: ""
    }
  }, [_c("app-input", {
    attrs: {
      value: (_vm$romaneio$plotData = _vm.romaneio.plotData) === null || _vm$romaneio$plotData === void 0 ? void 0 : _vm$romaneio$plotData.name,
      disabled: ""
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Sub-Área",
      expanded: ""
    }
  }, [_c("app-input", {
    attrs: {
      value: (_vm$romaneio$subPlotD = _vm.romaneio.subPlotData) === null || _vm$romaneio$subPlotD === void 0 ? void 0 : _vm$romaneio$subPlotD.nickname,
      disabled: ""
    }
  })], 1), _vm._v(" "), _c("hr"), _vm._v(" "), _c("div", {
    staticClass: "products-header"
  }, [_c("h4", [_vm._v("Produtos")]), _vm._v(" "), _vm.hasConvertion ? _c("button", {
    staticClass: "button is-small is-light",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.toggleConvertion
    }
  }, [_vm._v("\n            " + _vm._s(_vm.showWithoutConvertion ? "Converter" : "Mostrar sem converção") + "\n          ")]) : _vm._e()]), _vm._v(" "), _vm.romaneio.products ? _c("div", _vm._l(_vm.romaneio.products, function (product, idx) {
    return _c("b-field", {
      key: idx,
      attrs: {
        grouped: ""
      }
    }, [_c("b-field", {
      staticClass: "mt-8",
      attrs: {
        label: "Produto"
      }
    }, [_c("div", [_c("b-field", {
      attrs: {
        expanded: "",
        grouped: ""
      }
    }, [_c("b-field", {
      attrs: {
        label: "Quantidade de Caixas",
        expanded: ""
      }
    }, [_c("app-input", {
      attrs: {
        value: _vm.getBoxes(product),
        type: "number",
        disabled: ""
      }
    })], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "Peso por Caixa (Kg)"
      }
    }, [_c("money", _vm._b({
      staticClass: "input",
      attrs: {
        value: _vm.getWeightPerBox(product),
        type: "text",
        id: "uname",
        disabled: ""
      }
    }, "money", _vm.money, false))], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "Peso Total (Kg)"
      }
    }, [_c("money", _vm._b({
      staticClass: "input",
      attrs: {
        value: _vm.getTotalWeight(product),
        type: "text",
        id: "uname",
        disabled: ""
      }
    }, "money", _vm.money, false))], 1)], 1), _vm._v(" "), _c("b-field", {
      staticClass: "mt-8",
      attrs: {
        expanded: "",
        grouped: ""
      }
    }, [_c("b-field", {
      attrs: {
        label: "Valor por Caixa (R$)"
      }
    }, [_c("money", _vm._b({
      staticClass: "input",
      attrs: {
        value: _vm.getPricePerBox(product),
        prefix: "R$ ",
        type: "text",
        id: "uname",
        disabled: ""
      }
    }, "money", _vm.money, false))], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "Valor Total (R$)"
      }
    }, [_c("money", _vm._b({
      staticClass: "input",
      attrs: {
        value: _vm.getTotalPrice(product),
        prefix: "R$ ",
        type: "text",
        id: "uname",
        disabled: ""
      }
    }, "money", _vm.money, false))], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "Valor de Conversão"
      }
    }, [_c("money", _vm._b({
      staticClass: "input",
      attrs: {
        value: _vm.formatNumber(product.convertion),
        type: "text",
        id: "uname",
        disabled: ""
      }
    }, "money", _vm.money, false))], 1)], 1)], 1)])], 1);
  }), 1) : _vm._e()], 1)])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;